import * as tslib_1 from "tslib";
var CsAgGridJsScriptHandlerService = /** @class */ (function () {
    function CsAgGridJsScriptHandlerService() {
        this.scriptElement = null;
        this.isLoaded = false;
        this.loadPromise = null;
        this.scriptUrl = 'javascripts/ag-grid-enterpriseV33.1.0/ag-grid-enterprise.min.js';
    }
    /* Note: Handling the ag-grid CDN script dynamically.
     - Due to the issue of conflicting the styles & functionalities b/w AG-Grid Angular & AG-Grid Js approaches.
     */
    CsAgGridJsScriptHandlerService.prototype.loadAgGridScript = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoaded || window.agGrid) {
                            return [2 /*return*/, Promise.resolve()]; // ag-Grid is already in memory, no need to reload
                        }
                        if (this.loadPromise) {
                            return [2 /*return*/, this.loadPromise];
                        }
                        this.loadPromise = new Promise(function (resolve, reject) {
                            _this.scriptElement = document.createElement('script');
                            _this.scriptElement.src = _this.scriptUrl;
                            _this.scriptElement.async = true;
                            _this.scriptElement.onload = function () {
                                _this.isLoaded = true;
                                resolve();
                            };
                            _this.scriptElement.onerror = function () {
                                _this.isLoaded = false;
                                _this.loadPromise = null;
                                reject(new Error('Failed to load ag-Grid JS'));
                            };
                            document.body.appendChild(_this.scriptElement);
                        });
                        return [4 /*yield*/, this.isGridInstanceAvailable()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.loadPromise];
                }
            });
        });
    };
    CsAgGridJsScriptHandlerService.prototype.isGridInstanceAvailable = function () {
        var _this = this;
        // Wait until ag-Grid JS is fully available
        return new Promise(function (resolve) {
            var attempts = 0;
            var interval = setInterval(function () {
                attempts++;
                var agGrid = window.agGrid;
                if (_this.isLoaded && agGrid && agGrid.createGrid) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);
        });
    };
    // Add a method to verify script is loaded
    CsAgGridJsScriptHandlerService.prototype.isScriptLoaded = function () {
        var agGrid = window.agGrid;
        return !!(agGrid && agGrid.createGrid);
    };
    // Add a method to get script status for debugging
    CsAgGridJsScriptHandlerService.prototype.getScriptStatus = function () {
        var agGrid = window.agGrid;
        return {
            isLoaded: this.isLoaded,
            agGridExists: !!agGrid,
            createGridExists: !!(agGrid && agGrid.createGrid),
            scriptElementExists: !!this.scriptElement
        };
    };
    // Reset script handler state to allow reload
    CsAgGridJsScriptHandlerService.prototype.resetScriptState = function () {
        this.isLoaded = false;
        this.loadPromise = null;
    };
    CsAgGridJsScriptHandlerService.prototype.removeAgGridScript = function () {
        if (this.scriptElement) {
            this.scriptElement.remove(); // Detach from DOM but keep in memory
            this.scriptElement = null;
        }
    };
    return CsAgGridJsScriptHandlerService;
}());
export { CsAgGridJsScriptHandlerService };
